import moment from "moment";
import UserContext from '../../../services/Context/UserContext'
import Tip from '../../Tools/Tip';
import ActivityIcon from './Icon';
import { Link } from "react-router-dom";
import {useContext} from "react";
import { Stack, Box, useTheme } from "@mui/material";

export default function Activity({activity, onDelete}){

    const {user} = useContext(UserContext)

    const theme = useTheme();

    const a = activity;

    const actions = ['note','deal','reminder'].includes(a.type?.id)
        && (a.createdBy?.id === user?.id);


    const typeIs = t => t === a.type?.id


    return <div className="activity" data-id={a.id}>

        <div className="activity-line">

            <Box sx={{mt: 1, mb: 1, opacity: 0.7}}>
                <ActivityIcon type={a.type?.id} />
            </Box>

            <div className="activity-bar"></div>

        </div>


        <Stack className="activity-content" direction='column' spacing={2}>

            {typeIs('note') && <Note activity={a}/>}

            {typeIs('call') && <Call call={a.data}/>}

            {typeIs('deal') && <Deal deal={a}/>}

            {typeIs('email') && <Email />}

            {typeIs('reminder') && <Reminder reminder={a} />}

            {a.taggedUser && <Box sx={{color: theme.palette.primary.main}}>{a.taggedUser?.at}</Box>}

            {a.note && <Box>{a.note}</Box>}

            <Info a={a} />

        </Stack>
        
        
        <div className="activity-actions">
            {actions &&
                <Tip type='delete' onClick={() => onDelete()} />
            }
        </div>
        

    </div>
}




const Email = () => {

    const theme = useTheme();

    const blue = {color: theme.palette.primary.main};

    return <span style={blue}>&#x2713; Email envoyé</span>
}



function Deal({deal}){

    const theme = useTheme();

    const blue = {color: theme.palette.primary.main};
    const red = {color: theme.palette.error.main};

    const text = `${deal.winsCount} vente${deal.winsCount > 1 ? 's' : ''}`;

    const status = {
        1: <span style={blue}>&#x27B9; Affaire en cours</span>,
        2: <span style={blue}>&#x27B9; Affaire gagnée et toujours en cours - {text}</span>,
        3: <span style={blue}>&#x2713; Affaire gagnée - {text}</span>,
        4: <span style={red}>&#x2717; Affaire expirée</span>
    };

    const s = deal.inProgress ? (deal.won ? 2 : 1) : (deal.won ? 3 : 4);
 
    return <>
        {status[s]}
        <Events items={deal.events} />
    </>;

}


function Reminder({reminder}){
 
    return <span>Le {moment(reminder.expiredAt).format('DD/MM/YYYY à HH:mm')}</span>;
}



function Call({call}){

    let start = moment('2000-01-01 00:00:00.000').valueOf();
    let end = (call.duration || 0) * 1000 + start;
    let time = moment(end).format('HH:mm:ss');

    const theme = useTheme();

    const blue = {color: theme.palette.primary.main};
    const red = {color: theme.palette.error.main};

    return <>
        {call.user 
            ? (call.direction.startsWith('in') 
                ? <span style={blue}>&#x2798; Appel entrant</span>
                : <span style={blue}>&#x279A; Appel sortant</span>
            )
            : (call.direction.startsWith('in') 
                ? <span style={red}>&#x2798;  Appel manqué</span>
                : <span style={red}>&#x279A; Appel manqué</span>
            )
        }

        {call.voicemail && 
            <figure className="audio">
                <audio controls src={call.voicemail}></audio>
            </figure>
        }

        {call.recording && 
            <figure className="audio">
                <audio controls src={call.recording}></audio>
            </figure>
        }

        {false && <small>Durée : {time}</small>}
    </>
}


function Info({a}){

    const date = moment(a.createdAt).format('DD/MM/YYYY à HH:mm')

    const name = a.createdBy?.name || 'Inconnu';

    const link = a.user.id && 
        <>pour <Link to={`/crm/persons/${a.user.id}`}>{a.user.name}</Link></>

    return <Box sx={{opacity: 0.5, fontSize: '0.9em'}}>
        {a.type?.id !== 'flag' ? 
            <>Créé par {name} le {date} {link}</>:
            <>Le {date}</>
        }
    </Box>
}


function Note({activity}){

    return <Events items={activity.events} />
}


function Events({items}){

    return items?.length > 0 && 
        <span>{items?.map(i => i.title).join(', ')}</span>
}